import { Injectable, inject } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private localStorage: StorageService;

  constructor() {
    this.localStorage = inject(LOCAL_STORAGE);
  }

  setLogo(logo: any) { this.localStorage.set('logo', logo); }
  getLogo(): string | null { return this.localStorage.get('logo') || null; }

  getCustomer(): any | null {
    const customer = this.localStorage.get('customer');
    return customer ? JSON.parse(customer) : null;
  }
  setCustomer(customer: any) { if (customer) { this.localStorage.set('customer', JSON.stringify(customer)); } }

  setPermissions(permissions: any): void { this.localStorage.set('permissions', JSON.stringify(permissions)); }

  getPermissions(): any {
    const data = this.localStorage.get('permissions');
    return data ? JSON.parse(data) : null;
  }

  setToken(token: any): void { this.localStorage.set('token', token); }
  getToken(): string | null { return this.localStorage.get('token') || null; }

  setRefreshToken(token: string): void { this.localStorage.set('refreshToken', token); }
  getRefreshToken(): string | null { return this.localStorage.get('refreshToken') || null; }

  getExpiryTime(): string | null { return this.localStorage.get('expiryTime') || null; }
  setExpiryTime(expiryTime: string): void { this.localStorage.set('expiryTime', expiryTime); }

  setLoggedUser(user: any): void { this.localStorage.set('user', JSON.stringify(user)); }

  getLoggedUser(): any {
    const user = this.localStorage.get('user');
    return user ? JSON.parse(user) : null;
  }

  setCurrentProject(project: any): void { this.localStorage.set('project', JSON.stringify(project)); }

  getCurrentProject(): any {
    const project = this.localStorage.get('project');
    return project ? JSON.parse(project) : null;
  }

  isLogged(): boolean { return !!this.getLoggedUser(); }

  logout(): Promise<void> {
    this.clearSessionData();
    return Promise.resolve();
  }

  clearSessionData(): void {
    ['user', 'token', 'expiryTime', 'refreshToken', 'permissions', 'project', 'logo', 'customer'].forEach((key) => {
      this.localStorage.remove(key);
    });
  }
}
